<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top">
            <BackLink/>
        </div>
        <h1>{{ title }}</h1>
        <Form :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          :submitButtonText="buttonText"
          @submit="submitSection">   
            <span class="caption-xl" v-if="subtitle != ''">{{subtitle}}</span>
            <Fieldset :title="title" type="heading">
                <div :class="['form-group']">
                    <div class="grid-row push__bottom">
                      <Textarea
                        id="hobbies"
                        name="hobbies"
                        :label="questionHobbies"
                        errorMessage="This field is required"
                        v-model="form.hobbies"
                        :validate="$v.form.hobbies"
                      />
                    </div> 
                    <div class="grid-row push__top push__bottom">
                        <div class="grid-col grid-xsmall-12 grid-medium-12 grid-large-12">
                          <div :class="['form-group', {'form-group--error' : $v.form.questions.$anyError}]">
                              <h2 class="gamma">{{questionLead}}</h2>
                              <span class="caption-m">{{questionLeadSub}}</span>
                              <div class="push__top push__bottom--double">
                                <div class="grid-row push__bottom" v-for="(q, index) in questions" :key="'q' + q.id">
                                  <Dropdown :hideLabel="true" 
                                              :label="q.question"
                                              :name="'q' + q.id" 
                                              :id="'q' + q.id" 
                                              :options="q.answers"
                                              :answerLabels="questionLabels"
                                              v-model="form.questions[index].answer"
                                              :validate="$v.form.questions[index].answer"/>
                                </div> 
                              </div>
                            </div>
                        </div>
                    </div>       
                    <div :class="['form-group', {'form-group--error' : $v.form.worries.$error}]">
                      <Fieldset
                        :title="questionWorries.label"
                        type="default">
                              <span id="input-ex-worries" class="error-message" v-if="$v.form.worries.$error">Please select either yes or no</span>
                              <div v-for="option in questionWorries.answers" :key="'worries' + option.id">
                                <RadioButton :label="option.label" name="worries" :id="'worries' + option.id" :value="option.id" :model="worriesAnswer" @change="changeWorries"/>
                              </div>
                      </Fieldset>  
                    </div>

                    <div class="grid-row push__top push__bottom">
                      <Textarea
                        id="help"
                        name="help"
                        errorMessage="This field is required"
                        :label="questionHelp"
                        v-model="form.help"
                        :validate="$v.form.help"
                      />
                    </div>    
                    <div class="grid-row push__top push__bottom">
                      <Textarea
                        id="clinic"
                        name="clinic"
                        :label="questionClinic"
                        errorMessage="This field is required"
                        v-model="form.clinic"
                        :validate="$v.form.clinic"
                      />
                    </div> 
                </div>
            </Fieldset>

            
        </Form>        
      </article>
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "SectionOfEpilepsyQuestions",
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  data() {
    return {
      id : "",
      title: "",
      content: "",
      subtitle: "",
      destination: "",
      errorMessage: "Please ensure all questions are answered and valid.",
      worriesAnswer: null,
      answers: [], 
      questions: [],
      questionLead: "",
      questionLeadSub: "",
      questionLength : 0,
      questionHobbies : "",
      questionWorries : {},
			questionHelp : "",
			questionClinic : "",
      worries: [],
      form : {
          questions: [],
          hobbies: "",
          worries: null,
          help: "",
          clinic: ""
      }
    };
  },
  validations() {
      const validations = { 
        form : {
          questions: {},
          hobbies: { required },
          worries: { required },
          help: { required },
          clinic: { required }
        }
      };
      for (var a = 0; a < this.questionLength; a++) {
          validations.form.questions[a] = {
            answer : { required }
          }
      }
      return validations;
  },
  methods: {    
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.questions = currentQuestion.questions;
      this.questionLength = currentQuestion.questions.length;
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.subtitle = currentQuestion.subtitle;
      this.buttonText = currentQuestion.buttonText;
      this.questionLead = currentQuestion.questionLead;
      this.questionLeadSub = currentQuestion.questionLeadSub;
      this.questionLabels = currentQuestion.questionLabels;
      this.destination = currentQuestion.destination;
      this.questionHobbies = currentQuestion.questionHobbies;
      this.questionWorries = currentQuestion.questionWorries
			this.questionHelp = currentQuestion.questionHelp;
			this.questionClinic = currentQuestion.questionClinic;
      this.formatQuestions();
    },
    loadAnswer() {
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      console.log(previousResponse);
      if (previousResponse) {
        for (var a = 0; a < this.questionLength; a++) {
            this.form.questions[a].answer = previousResponse.questions[a].answer;
        }
        this.form.worries = previousResponse.worries.answer;
        this.worriesAnswer = previousResponse.worries.answer;
        var worriesRadio = document.getElementById('worries' + previousResponse.worries.answer);
        worriesRadio.checked = true;
        this.form.hobbies = previousResponse.hobbies.answer;
        this.form.help = previousResponse.help.answer;
        this.form.clinic = previousResponse.clinic.answer;
        
      }
    },
    changeWorries: function(newValue) {
      console.log(newValue);
      this.worriesAnswer = newValue;
      this.form.worries = this.worriesAnswer;
      console.log(this.form.worries);
    },
    formatQuestions(){
      // Empty Questions Base
      for (var b = 0; b < this.questionLength; b++) {
          this.form.questions.push({
            id: this.questions[b].id,
            question: this.questions[b].question,
            answer: null
          });
      }
    },
    startQuestionnaire() {        
      this.$router.push({ path: this.destination });
    },
    changeValue(index, newValue) {
        this.form.questions[index].answer = newValue;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "SectionOfEpilepsyQuestions",
        questions: this.form.questions,
        hobbies: {
          question: this.questionHobbies.label,
          answer: this.form.hobbies
        },
        worries: {
          question: this.questionWorries.label,
          answer: this.form.worries
        },
        help: {
          question: this.questionHelp.label,
          answer: this.form.help,
        },
        clinic: {
          question: this.questionClinic.label,
          answer: this.form.clinic
        }
      };
      dataService.logResponse(response);
    },
    submitForm(form, valid) {
        valid.$touch();
        if (valid.$pending || valid.$error) {
            setTimeout(() => {
                document.querySelector(".error-summary__link").focus()
            }, 0);
            return;	
        }
      this.logResponse();
      if(this.id == "YoungPersonMeAndMyEpilepsyQuestionnaire") {
        let patientData = dataService.getPatientData();
        if(patientData.age > 10 && patientData.age < 18 && patientData.withoutHelp == "Yes") {
          this.destination = "YoungPersonQuestionnaire11to17"
        } else {
          this.destination = "YoungPersonQuestionnaire11to17Complete"
        }
      }
      
      this.$router.push({ name: this.destination.toLowerCase() });
      
    },
    submitSection() {
      this.submitForm(this.form, this.$v.form);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>